/* eslint-disable react/button-has-type */
import CN from 'classnames';
import { FC } from 'react';

import { Loader } from '../Loader';

export interface ButtonProps {
  className?: string | undefined;
  disabled?: boolean | undefined;
  isLoading?: boolean | undefined;
  appearance?: 'primary' | 'secondary' | 'link' | undefined;
  onClick?: (e: any) => void | undefined;
  isBlock?: boolean;
  isRounded?: boolean;
  size?: 'sm' | 'md';
  [x: string]: any;
}

export const Button: FC<ButtonProps> = ({
  children,
  disabled,
  className,
  appearance,
  isLoading,
  isBlock,
  isRounded,
  onClick,
  size = 'sm',
}: ButtonProps) => {
  const ButtonClasses = CN(
    'button h-fit font-semibold text-white rounded-[8px]',
    className,
    {
      'bg-[#F7941E] disabled:bg-[#F7941E] disabled:bg-opacity-70':
        appearance === 'primary' || !appearance,
      'border border-1 border-[#C3D3E2] disabled:border-neutral-300 !text-[#0F3659] hover:bg-neutral-100':
        appearance === 'secondary',
      'underline !text-[#F7941E]': appearance === 'link',
      '!rounded-full': isRounded,
      'px-[30px] py-[14px] text-[16px] leading-[18px]': size === 'md',
      'px-[20px] py-[10px] text-[14px] leading-[16px]': size === 'sm',
    },
    {
      'cursor-not-allowed !opacity-70': disabled,
      'cursor-pointer': !disabled,
    },
    {
      'w-full': isBlock,
      'w-fit': !isBlock,
    },
  );

  return (
    <button onClick={onClick} disabled={disabled || isLoading} className={ButtonClasses}>
      <div className="relative w-full">
        <div
          className={CN({
            'opacity-0 flex items-center justify-center font-medium': isLoading,
            'opacity-100 flex items-center justify-center': !isLoading,
          })}
        >
          {children}
        </div>
        {isLoading && (
          <div className="absolute translate-x-[-50%] translate-y-[-130%] left-[50%]">
            <Loader
              appearance={appearance === 'secondary' || appearance === 'link' ? 'black' : 'default'}
            />
          </div>
        )}
      </div>
    </button>
  );
};

Button.defaultProps = {
  className: undefined,
  onClick: undefined,
  isLoading: false,
  isBlock: false,
  appearance: undefined,
};

export default Button;
